import React from 'react';
import SubcategoriesFilter from 'components/list/Filters/types/SubcategoriesFilter';

const SubCategoryIdFilter = <SubcategoriesFilter
    label='filters.components.subcategoryId.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='subcategory_id'
    parentNode='category_id'
/>;

export default SubCategoryIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/SubCategoryIdFilter.js